'use strict';
const goldAsset = require('./gold-asset');
module.exports = function GoldIconPacker(resourceManager, pageState) {
	if (!resourceManager || !pageState) {
		throw 'invalid-args';
	}
	const self = this;
	self.pack = function (ideaArray) {
		const fileId = pageState.getFileId();
		ideaArray.forEach(function (idea) {
			const icon = idea && idea.attr && idea.attr.icon;
			if (icon) {
				icon.metaData = goldAsset.metadataForGoldAsset(icon.url, fileId);
				icon.url = resourceManager.getResource(icon.url);
			}
		});
	};
};
